var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOceano(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5859 15.2734C44.929 15.2734 47.3634 19.8988 47.3796 19.9301C48.4228 22.0732 51.5778 22.0725 52.6204 19.9301C52.6436 19.8834 55.0702 15.2734 59.4141 15.2734C61.0321 15.2734 62.3438 13.9617 62.3438 12.3438C62.3438 10.7258 61.0321 9.41406 59.4141 9.41406C55.0968 9.41406 51.9794 11.623 50.0001 13.7055C48.0206 11.623 44.9032 9.41406 40.5859 9.41406C36.7042 9.55742 36.7046 15.1303 40.5859 15.2734Z",
    fill: "url(#paint0_linear_1939_71)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9659 5.85938C76.309 5.85938 78.7434 10.4848 78.7596 10.516C79.8028 12.6592 82.9578 12.6584 84.0004 10.516C84.0237 10.4693 86.4502 5.85938 90.7942 5.85938C92.4121 5.85938 93.7238 4.54766 93.7238 2.92969C93.7238 1.31172 92.4121 0 90.7942 0C86.4768 0 83.3594 2.20898 81.3801 4.29141C79.4006 2.20898 76.2834 0 71.9659 0C68.0842 0.143359 68.0846 5.71621 71.9659 5.85938Z",
    fill: "url(#paint1_linear_1939_71)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6665 51.2695C61.305 51.2695 57.7054 57.9361 49.9999 57.9361C42.2866 57.9361 38.7044 51.2695 33.3333 51.2695C27.9718 51.2695 24.3724 57.9361 16.6668 57.9361C8.9533 57.9361 5.37128 51.2695 0 51.2695V71.5756C7.71327 71.5756 11.2955 78.2422 16.6666 78.2422C22.0281 78.2422 25.6275 71.5756 33.3331 71.5756C41.0464 71.5756 44.6286 78.2422 49.9997 78.2422C55.3612 78.2422 58.9608 71.5756 66.6663 71.5756C74.3795 71.5756 77.961 78.2422 83.3328 78.2422C88.6944 78.2422 92.294 71.5756 99.9994 71.5756V51.2695C94.6379 51.2695 91.0383 57.9361 83.3328 57.9361C75.62 57.9361 72.0378 51.2695 66.6665 51.2695Z",
    fill: "url(#paint2_linear_1939_71)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9533 25.9551C91.6758 27.7521 88.5092 31.7709 83.3332 31.7709C76.6666 31.7709 73.3333 25.1043 66.6667 25.1043C60.0001 25.1043 56.6667 31.7709 50.0001 31.7709C43.3335 31.7709 40.0001 25.1043 33.3335 25.1043C26.6669 25.1043 23.3335 31.7709 16.667 31.7709C11.491 31.7709 8.3242 27.7521 4.04687 25.9551C2.12363 25.1471 0 26.5789 0 28.6646V45.4102C7.71327 45.4102 11.2955 52.0768 16.6666 52.0768C22.0281 52.0768 25.6275 45.4102 33.3331 45.4102C41.0464 45.4102 44.6286 52.0768 49.9997 52.0768C55.3612 52.0768 58.9608 45.4102 66.6663 45.4102C74.3795 45.4102 77.961 52.0768 83.3328 52.0768C88.6944 52.0768 92.294 45.4102 99.9994 45.4102V28.6646C99.9998 26.5789 97.8762 25.1471 95.9533 25.9551Z",
    fill: "url(#paint3_linear_1939_71)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6665 77.435C61.305 77.435 57.7054 84.1016 49.9999 84.1016C42.2866 84.1016 38.7044 77.435 33.3333 77.435C27.9718 77.435 24.3724 84.1016 16.6668 84.1016C8.9535 84.1016 5.37128 77.435 0.000195312 77.435V97.0703C0.000195312 98.6883 1.31191 100 2.92988 100H97.0703C98.6883 100 100 98.6883 100 97.0703V77.435C94.6385 77.435 91.0389 84.1016 83.3334 84.1016C75.62 84.1016 72.0378 77.435 66.6665 77.435Z",
    fill: "url(#paint4_linear_1939_71)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1939_71",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1939_71",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1939_71",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1939_71",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1939_71",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceano);
export default __webpack_public_path__ + "static/media/oceano.3bc7c46c4e3a17f498462d7cb3051267.svg";
export { ForwardRef as ReactComponent };